import {
    SET_PROJECT_IS_OPEN,
} from './constants';

export const setProjectIsOpen = isOpen => ({
    type: SET_PROJECT_IS_OPEN,
    isOpen,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectAddress/actions.js